import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { ReactSVG } from 'react-svg';
import { i18n as I18n } from '../../../utils/i18n';

// hooks
import { useApiRequest } from '../../../hooks/useApiRequest';

const icons = {
  email: '../../../images/icons/email.svg',
};

const Confirmation = ({ email, existingCompany }) => {
  const [responseMessage, setResponseMessage] = useState({
    error: false,
    content: null,
  });

  const apiRequest = useApiRequest();

  const responseClasses = classNames({
    'registration-confirmation__response-message': true,
    'registration-confirmation__response-message--error': responseMessage.error,
  });

  const resendValidationEmail = useCallback(async () => {
    await apiRequest
      .get(`/v1/users/registrations/resend_validation_email?email=${email}`)
      .then(() => {
        setResponseMessage({
          error: false,
          content: I18n.t('registration.confirmation.validation_email_sent'),
        });
      })
      .catch(error => {
        setResponseMessage({
          error: true,
          content: error.response.data.message,
        });
      });
  }, [apiRequest, email]);

  return (
    <div className="registration-confirmation">
      <h3 data-cy="registrationHeader">
        {I18n.t('registration.confirmation.title')}
      </h3>
      <p className="registration-confirmation__instructions">
        {I18n.t('registration.confirmation.instructions')}
      </p>
      <ReactSVG
        className="registration-confirmation__email_icon"
        src={icons.email}
      />
      <p className="registration-confirmation__message">
        {!existingCompany &&
          I18n.t('registration.confirmation.new_account_message')}
        {existingCompany &&
          I18n.t('registration.confirmation.existing_account_message')}
      </p>
      <p className="registration-confirmation__actions">
        <a className="button button--primary" href="/" data-cy="homeButton">
          {I18n.t('registration.confirmation.return_to_homepage')}
        </a>
        <br />
        {!existingCompany && (
          <>
            <a className="button button--text" onClick={resendValidationEmail}>
              {I18n.t('registration.confirmation.re_request_email')}
            </a>

            {responseMessage.content && (
              <p className={responseClasses}>{responseMessage.content}</p>
            )}
          </>
        )}
      </p>
    </div>
  );
};

Confirmation.propTypes = {
  email: PropTypes.string.isRequired,
  existingCompany: PropTypes.bool,
};

export default Confirmation;
